module.exports = __webpack_public_path__ + "img/pic_location_Taitung.390ee083.png";